module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Показать ' + this.topCount : _vm.loadedPages === 0 ? 'Загрузить' : 'Еще',
      "expandable": !((_vm.totalPages == _vm.loadedPages) && (this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading && _vm.loadedPages < 0),
      expression: "isLoading && loadedPages < 0"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.isLoading && _vm.loadedPages == 0)),
      expression: "!(isLoading && loadedPages == 0)"
    }]
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v(" История просмотров")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "pb-0": ""
      }
    }, [_vm._v(_vm._s(item.accountNameShort))]), _c('v-flex', {
      attrs: {
        "pb-0": "",
        "align-end": ""
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.created, _vm.formats.formatDateTime)))])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c99fd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/VisitPanel.vue
// module id = 1087
// module chunks = 1